export default __webpack_public_path__ + "static/media/1988.60ab3fbc.png";